import React from 'react'
import TextField from '@mui/material/TextField'
import { InputProps } from './Input.types'

export const Input = ({
  ariaLabel,
  label,
  onChange,
  value,
  className,
  name,
  disabled = false,
  ...otherProps
}: InputProps) => {
  return (
    <TextField
      label={label}
      disabled={disabled}
      variant="outlined"
      value={value}
      onChange={onChange}
      inputProps={{
        'aria-label': ariaLabel,
        name,
      }}
      className={className}
      {...otherProps}
    />
  )
}
